import React, {Component} from 'react'
import {
    Form,
    Input,
    Row,
    Col,
    Select,
    DatePicker,
    Button,
    Table
} from 'antd';
import {baseUrl, reqLogisticsList} from '../../api'
import LinkButton from '../../components/link-button'
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthLinkButton = authorizeBase(LinkButton)
const AuthButton = authorizeBase(Button)
const {Option} = Select;
const orderStatus = {
    audit: '待审核',
    audited: '待订舱',
    booked: '已订舱',
    boxed: '已装箱',
    declare: '待报关',
    declaring: '报关中',
    released: '已放行'
};

const logisticsStatus = {
    waiting: "待提货",
    transport: '运输中',
    declaring: '报关中',
    boxed: '已装箱',
    released: '已放行',
    destination: '已到达'
}
class DeliveryList extends Component {

    state = {
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        pageNum: 1,
        searchData: {},
        selectList: [],
        deliveryFromDt: null,
        deliveryToDt: null,
        sortData: {},
        arrow: 'up-arrow',
    }

    /*
     初始化table的列的数组
     */
    initColumns = () => {
        this.columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                sorter: true,
                render: (text, record) => (
                    <a onClick={() => this.props.history.push('/deliveryDetail', {orderId: record.id})}>{text}</a>
                )
            },
            /*{
             title: '总价',
             dataIndex: 'totalValue',
             },*/
            {
                title: '起运地',
                sorter: true,
                dataIndex: 'originCity',
                render: (text, record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            },
            {
                title: '转关地',
                sorter: true,
                dataIndex: 'destinationStartCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationStartCountry}&nbsp;{record.destinationStartCity}
                  </span>
                )
            }, {
                title: '目的地',
                sorter: true,
                dataIndex: 'destinationCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            }, {
                title: '还箱地',
                sorter: true,
                dataIndex: 'boxReturnStation',
            },
            {
                title: '装箱地',
                dataIndex: 'boxLocation',
                width:180,
                render: (text, record) => (
                    <span>
                    {record.orderDeliveryVos.map((c, i) => {
                            return <div key={c.id}>
                                {c.boxLocation}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            },
            {
                title: '汽运车号',
                dataIndex: 'orderVehicleVos',
                render: orderList => (
                    <span>
                    {orderList.map((c, i) => {
                            return <div key={c.id}>
                                {c.truckNo}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            },
            {
                title: 'gps编号',
                dataIndex: 'trailNo',
                render: (text, record) => (
                    <span>
                    {record.orderDeliveryVos.map((c, i) => {
                            return <div key={c.id}>
                                {c.trailNo}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            },
            {
                title: '集装箱号',
                dataIndex: 'boxNo',
                render: (text, record) => (
                    <span>
                    {record.orderDeliveryVos.map((c, i) => {
                            return <div key={c.id}>
                                {c.boxNo}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            }, {
                title: '预计提货时间',
                sorter: true,
                dataIndex: 'deliveryEstimateDt',
            }, {
                title: '提货时间',
                sorter: true,
                dataIndex: 'deliveryTime',
            }
            ,
            {
                title: '订单状态',
                sorter: true,
                dataIndex: 'orderStatus',
                width:100,
                render: (text, record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            }, {
                title: '物流状态',
                sorter: true,
                dataIndex: 'logisticsStatus',
                width:100,
                render: (text, record) => (
                    <span>
                        {logisticsStatus[text]}
                    </span>
                )
            }/*, {
                title: '备注说明',
                dataIndex: 'remarks',
            }*/
            , {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 100,
                render: (text, record) => (
                    <span>
                       <AuthLinkButton authority="delivery:edit"
                                       onClick={() => this.props.history.push('/deliveryEdit', {orderId: record.id})}>编辑</AuthLinkButton>
                    </span>
                )
            }
        ];
    }

    exportModel = () => {
        const {selectList} = this.state
        let orderNo = '';
        let boxNo = '';
        let entName = '';
        let departure = '';
        let destination = '';
        let orderStatus = '';
        let transitPoint = '';
        let boxReturnStation = '';
        let logisticsStatus = '';
        let deliveryFromDt2 = '';
        let deliveryToDt2 = '';
        let gpsNo = '';

        const {getFieldsValue} = this.props.form
        const searchData = getFieldsValue();
        const {deliveryFromDt, deliveryToDt} = this.state
        if (searchData.orderNo) {
            orderNo = searchData.orderNo
        }
        if (searchData.entName) {
            entName = searchData.entName
        }
        if (searchData.boxNo) {
            boxNo = searchData.boxNo
        }
        if (searchData.departure) {
            departure = searchData.departure
        }
        if (searchData.destination) {
            destination = searchData.destination
        }
        if (searchData.orderStatus) {
            orderStatus = searchData.orderStatus
        }
        if (searchData.transitPoint) {
            transitPoint = searchData.transitPoint
        }
        if (searchData.boxReturnStation) {
            boxReturnStation = searchData.boxReturnStation
        }
        if (searchData.logisticsStatus) {
            logisticsStatus = searchData.logisticsStatus
        }
        if (deliveryFromDt) {
            deliveryFromDt2 = deliveryFromDt
        }
        if (deliveryToDt) {
            deliveryToDt2 = deliveryToDt
        }
        if (searchData.gpsNo) {
            gpsNo = searchData.gpsNo
        }
        if (selectList && selectList.length > 0) {
            window.location.href = baseUrl + "/api/v1/p/oms/exportList?ids=" + selectList;
        } else {
            window.location.href = baseUrl + "/api/v1/p/oms/exportList?" + "orderNo=" + orderNo + "&boxNo=" + boxNo + "&departure=" + departure
                + "&destination=" + destination + "&orderStatus=" + orderStatus + "&logisticsStatus=" + logisticsStatus + "&deliveryFromDt=" + deliveryFromDt2
                + "&deliveryToDt=" + deliveryToDt2+ "&transitPoint=" + transitPoint + "&boxReturnStation=" + boxReturnStation + "&entName=" + entName
                + "&gpsNo=" + gpsNo;
        }

    }


    componentWillMount() {
        this.initColumns()
    }

    getProducts = async (pageNum, sortData) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        })
        const {getFieldsValue} = this.props.form
        const searchData = getFieldsValue();
        const {deliveryFromDt, deliveryToDt} = this.state
        searchData.deliveryFromDt = deliveryFromDt;
        searchData.deliveryToDt = deliveryToDt;
        searchData.pageNum = pageNum;
        searchData.pageSize = pageSize;
        if (sortData) {
            searchData.sort = sortData.sort
            searchData.order = sortData.order
        }
        if (!searchData.orderStatus) {
            searchData.notInStatusStr = 'new,audit,failed';
        }
        let result = await reqLogisticsList(searchData)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    handleSubmit = (event) => {
        // 阻止事件的默认行为
        event.preventDefault()
        // 对所有表单字段进行检验
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {sortData} = this.state
            if (err) {
                return;
            }
            this.setState({
                searchData: values
            })
            this.getProducts(1, sortData);
        });
    }

    componentDidMount() {
        this.getProducts(1)
        var box=document.getElementById("all");
        if(box){ //此处在加一层判断，更加严密，如果box存在的情况下获取
            this.setState({
                allHeight:box.offsetHeight
            })
        }
    }

    // 日期选择
    onDateChange = (value, dateString) => {
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        this.setState({
            deliveryToDt: dateString
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        const sortData = {
            sort: sorter.field,
            order: sorter.order,
        }
        this.setState({
            sortData
        })
        this.getProducts(pageNum, sortData)
    };
    moreClick = () => {
        const {arrow} = this.state;
        this.setState({
            arrow: arrow === 'down-arrow' ? 'up-arrow' : 'down-arrow'
        })
    };
    render() {

        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 8},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 12},
                sm: {span: 12},
            },
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                if (selectedRows && selectedRows.length > 0) {
                    let idListb = selectedRows.map((o) => {
                        return o.id
                    })
                    this.setState({
                        selectList: idListb
                    })
                } else {
                    this.setState({
                        selectList: null
                    })
                }
            }
        }

        // 取出状态数据
        const {orderList, total} = this.state

        return (
            <div id='all'>
                <div className='box-shadow margin-bootom'>
                    <div className='head-title'>物流信息列表
                        <span className="arrow" onClick={this.moreClick}>{this.state.arrow === 'down-arrow' ? '收起':'更多'}<span className={this.state.arrow}></span></span></div>
                    <br/>
                    <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={6}>
                                <Form.Item label="订单编号">
                                    {getFieldDecorator('orderNo', {})(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="集装箱号">
                                    {getFieldDecorator('boxNo', {})(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="提货时间" className='time-input-to'>
                                    {getFieldDecorator('deliveryFromDt')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange} style={{width: "100%", minWidth: 10}}
                                    />)}

                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label={"至"} className='time-input-to'>
                                    {getFieldDecorator('deliveryToDt')(<DatePicker
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange2} style={{width: "100%", minWidth: 10}}
                                    />)}
                                </Form.Item>
                            </Col>
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="起运地">
                                    {getFieldDecorator('departure', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="转关地">
                                    {getFieldDecorator('transitPoint', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="目的地">
                                    {getFieldDecorator('destination', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="还箱地">
                                    {getFieldDecorator('boxReturnStation', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="订单状态">
                                    {getFieldDecorator('orderStatus', {
                                        initialValue: '',
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Option value="">全部</Option>
                                        <Option value="audited">待订舱</Option>
                                        <Option value="booked">已订舱</Option>
                                        <Option value="boxed">已装箱</Option>
                                        <Option value="declare">待报关</Option>
                                        <Option value="declaring">报关中</Option>
                                        <Option value="released">已放行</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="物流状态">
                                    {getFieldDecorator('logisticsStatus', {
                                        initialValue: '',
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Option value="">全部</Option>
                                        <Option value="waiting">待提货</Option>
                                        <Option value="boxed">已装箱</Option>
                                        <Option value="transport">运输中</Option>
                                        <Option value="declaring">报关中</Option>
                                        <Option value="released">已放行</Option>
                                        <Option value="destination">已到达</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col> : null}
                            {this.state.arrow === 'down-arrow' ? <Col span={6}>
                                <Form.Item label="GPS编号">
                                    {getFieldDecorator('gpsNo', {})(<Input />)}
                                </Form.Item>
                            </Col> : null}
                            <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                <Button type='primary' htmlType="submit"
                                        style={{float: 'right', marginRight: '16.7%'}}>查询</Button>
                                <AuthButton authority="delivery:export" type="primary"
                                            onClick={this.exportModel} style={{float: 'right',marginRight:'20%'}}>导出</AuthButton>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <Table
                        rowSelection={rowSelection}
                        columns={this.columns}
                        dataSource={orderList}
                        rowKey='id'
                        bordered
                        scroll={{x: 2000,y: this.state.allHeight/1.7}}
                        onChange={this.handleTableChange}
                        pagination={{
                            current: this.state.pageNum,
                            total: total,
                            showQuickJumper: true,
                        }}
                        size="middle"
                    />
                </div>
            </div>

        )
    }
}
const DeliveryListFrom = Form.create()(DeliveryList)
export default DeliveryListFrom